export const EventCss = {
  eventDetailItem: {
    color: "#ddd",
    fontSize: "16px",
    fontWeight: 300,
    margin: "0 0 5px",
    display: "flex"
  },
  eventDetailTitle: {
    fontWeight: 500,
    fontSize: "18px",
    display: "inline-block",
    marginRight: "10px",
    color: "#f4181c"
  },
  eventSharePanel: {
    display: "flex" as const,
    flexWrap: "wrap" as const,
    justifyContent: "space-between",
    margin: "37px 0 0",
    padding: "12px 0",
    borderTop: "1px solid #252525",
    borderBottom: "1px solid #252525",
    paddingRight: "calc(var(--bs-gutter-x) * .5)",
    paddingLeft: "calc(var(--bs-gutter-x) * .5)"
  },
  likeDislikeButton: {
    border: "none",
    backgroundColor: "transparent",
    color: "#ffffff",
    WebkitTransition: "all 0.4s ease 0",
    transition: "all 0.4s ease 0s"
  },
  shareIcon: {
    fontSize: "14px",
    width: "35px",
    height: "35px",
    display: "inline-flex" as const,
    webkitBoxPack: "center" as const,
    justifyContent: "center" as const,
    alignItems: "center",
    borderRadius: "100%",
    color: "#ffffff",
    marginRight: "10px",
    border: "1px solid transparent"
  }
};
